// src/utils/zodiyakTips.ts hardened/refactored v1

export type TipSection = 
  | 'welcome' 
  | 'settings'
  | 'crushlist'
  | 'crushids'
  | 'matches';

export const zodiyakTips: Record<TipSection, string[]> = {
  welcome: [
    "Tap me anytime. I'm your Zodiyak. I know things.",
  ],

  crushlist: [
    "Add them. Worst case nothing happens. Best case — everything does.",
    "Curious, Like Like, or Down Bad. Find out the vibe you share.",
    "If they added you too, you both find out. If not — nobody ever knows.",
  ],

  crushids: [
    "This is how your crush finds you. Make it easy for them.",
    "Add your phone, email, socials — the more the better.",
    "Someone might already be looking for you right now.",
  ],

  settings: [
    "No one misses out when everyone's here. That's the whole point.",
    "Turn on notifications. You don't want to miss this one.",
    "Deactivate anytime. Your list stays saved.",
  ],

  matches: [
    "This is the moment. They added you. You added them.",
    "Go say something. You already know they want you to.",
    "This is why you downloaded the app.",
  ],
};